<template>
  <div class="policies">
    <b-tabs>
      <b-tab
        title="Cache policy"
        class="nav-link active"
        :active="routeName === 'cache-policies'"
        @click="changeView('cache-policies')"
      />
      <b-tab
        title="Origin request policy"
        class="nav-link"
        :active="routeName === 'request-policies'"
        @click="changeView('request-policies')"
      />
      <b-tab
        title="Image policy"
        class="nav-link"
        :active="routeName === 'image-policies'"
        @click="changeView('image-policies')"
      />
    </b-tabs>
    <transition
      name="fade"
      mode="out-in"
    >
      <parent>
        <router-view :key="$route.path" />
      </parent>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'PoliciesView',
  computed: {
    routeName() {
      return this.$route.name
    },
  },
  methods: {
    changeView(view) {
      this.$router.push({ name: view }).catch(() => {})
    },
  },
}
</script>
